export const normalizePathname = (pathname: string): string => {
  const _normalizedPathname = pathname.replace(/\/{2}/g, '/');
  if (!_normalizedPathname.startsWith('/')) {
    return `/${_normalizedPathname}`;
  }
  return _normalizedPathname;
};
